import React, { useState } from 'react';
import { chartsMaxYTick, roundNumber } from '../../../../../utils';
import { withDefaultPrintChart } from '../../../../../hoc';
import stringify from 'fast-json-stable-stringify';
import useDeepCompareEffect from 'use-deep-compare-effect';
import ApexCharts from "apexcharts";

const MomentChart = ({
    series: { bendingMoments = [] },
    chartTitle = '',
    yLabel = '',
    xLabel = '',
    chartOptions = {},
    onLoad,
}) => {
    const [options, setOptions] = useState(chartOptions);
    const [seriesState, setSeriesState] = useState([
        {
            name: '',
            data: [],
        },
    ]);

    useDeepCompareEffect(() => {
        setSeriesState(() => {
            return [
                {
                    name: 'Z',
                    data: [
                        ...bendingMoments.reduce((acc, ele, index) => {
                            return [...acc, [ele, index * 0.1]];
                        }, []),
                    ],
                },
            ];
        });
    }, [bendingMoments]);

    useDeepCompareEffect(() => {
        const maxMoment = Math.max(...bendingMoments);
        const minMoment = Math.min(...bendingMoments);

        setOptions((state) => {
            const maxZ = Math.ceil(
                Math.max(...seriesState[0].data.map((ele) => ele[1])),
            );
            const maxVal = Math.max(Math.abs(maxMoment), Math.abs(minMoment));

            const { maxNum, maxTick } = chartsMaxYTick(maxZ);
            return {
                ...state,
                title: {
                    ...state['title'],
                    text: chartTitle,
                    margin: 20,
                    offsetY: 10,
                    floating: true
                },
                grid: {
                    ...state['grid'],
                    show: true,
                    padding: {
                        top: 50,
                        bottom: 20,
                    }  
                },
                fill: {
                    ...state['fill'],
                    colors: ['#ff7f7f'],
                },
                stroke: {
                    ...state['stroke'],
                    colors: ['#b20000'],
                },
                subtitle: {
                    ...state['subtitle'],
                    align: 'center',
                    margin: 0,
                    offsetY: 90,
                    text: `Mmax - ${roundNumber(maxMoment,2)} kNm, Mmin - ${roundNumber(minMoment, 2)}kNm`,
                },
                yaxis: {
                    ...state['yaxis'],
                    tickAmount: maxTick,
                    max: maxNum,

                    title: {
                        ...state['yaxis']['title'],
                        text: yLabel,
                    },
                },
                xaxis: {
                    ...state['xaxis'],
                    max: 1.2 * maxVal,
                    min: -1.2 * maxVal,
                    tickAmount: 10,

                    title: {
                        ...state['xaxis']['title'],
                        offsetY: 30,
                        text: xLabel,
                    },
                    labels: {
                        ...state['xaxis']['labels'],
                        offsetY: 10
                    }
                },
                dataLabels: {
                    ...chartOptions['dataLabels'],
                    offsetY: 0,
                    offsetX: 0,

                    formatter: function (x, opt) {
                        const currentVal = roundNumber(opt.w.globals.initialSeries[0].data[opt.dataPointIndex][0],0);
    
                        return currentVal === 0
                            ? 
                            ''
                            :
                            opt.dataPointIndex % 7 === 0
                            ?
                                currentVal
                            :
                            ''
                    },
                },
            };
        });
    }, [
        bendingMoments,
        seriesState,
        chartTitle,
        xLabel,
        yLabel,
    ]);

    useDeepCompareEffect(() => {
        let chart = new ApexCharts(document.querySelector("#bendingChart"), {
            series: seriesState,
            ...options,
            chart: {
                ...options['chart'],
                type: 'area'
            }
        });
        chart.render();

        chart.dataURI().then(({ imgURI }) => {
            onLoad({ bendingChart: imgURI })
        });

        return () => chart.destroy();
    },[seriesState, options]);

    return (
        <div id="bendingChart"></div>
    );
};

export default React.memo(
    withDefaultPrintChart(MomentChart),
    (prev, next) => stringify(prev) === stringify(next),
);
